/**
 * 日本の都道府県標準順序（北から南へ）
 * JIS X 0401（都道府県コード）に基づく配列
 */
window.JapanPrefectureOrder = [
  // 北海道地方
  '北海道',

  // 東北地方
  '青森県',
  '岩手県',
  '宮城県',
  '秋田県',
  '山形県',
  '福島県',

  // 関東地方
  '茨城県',
  '栃木県',
  '群馬県',
  '埼玉県',
  '千葉県',
  '東京都',
  '神奈川県',

  // 中部地方
  '新潟県',
  '富山県',
  '石川県',
  '福井県',
  '山梨県',
  '長野県',
  '岐阜県',
  '静岡県',
  '愛知県',

  // 近畿地方
  '三重県',
  '滋賀県',
  '京都府',
  '大阪府',
  '兵庫県',
  '奈良県',
  '和歌山県',

  // 中国地方
  '鳥取県',
  '島根県',
  '岡山県',
  '広島県',
  '山口県',

  // 四国地方
  '徳島県',
  '香川県',
  '愛媛県',
  '高知県',

  // 九州地方・沖縄地方
  '福岡県',
  '佐賀県',
  '長崎県',
  '熊本県',
  '大分県',
  '宮崎県',
  '鹿児島県',
  '沖縄県',
];

/**
 * 都道府県名から順序インデックスを取得
 * @param {string} prefectureName 都道府県名
 * @returns {number} 順序インデックス（見つからない場合は999）
 */
window.getPrefectureOrderIndex = function (prefectureName) {
  const index = window.JapanPrefectureOrder.indexOf(prefectureName);
  return index === -1 ? 999 : index;
};

/**
 * 都道府県配列を標準順序でソート
 * @param {Array} provinces 都道府県配列 [[code, name], ...]
 * @returns {Array} ソート済み都道府県配列
 */
window.sortJapanProvinces = function (provinces) {
  if (!provinces || !Array.isArray(provinces)) {
    return provinces;
  }

  return provinces.sort(function (a, b) {
    const nameA = a[1]; // 都道府県名
    const nameB = b[1];

    const indexA = window.getPrefectureOrderIndex(nameA);
    const indexB = window.getPrefectureOrderIndex(nameB);

    return indexA - indexB;
  });
};
